import React from "react";
import get from "lodash/get";
import forEach from "lodash/forEach";
import { connect } from "react-redux";
import {
  Alert,
  Layout,
  Row,
  Col,
  Breadcrumb,
  Icon,
} from "antd";

import SettingsRoleSuperAdminForm from "../../components/SettingsRoleForm/SettingsRoleSuperAdminForm";
import classes from "./SettingsRoles.css";

import isAuthenticated from "../../utils/isAuthenticated";
import {
  getPermissionsStructureSuperAdminRequest,
  getPermissionsStructureRequest,
} from "../../api/requests";
import { logout, setPermissions } from "../../reducers/user/actions";
import {
  getUserToken,
} from "../../reducers/user/selectors";
import { withNamespaces } from "react-i18next";

const { Content } = Layout;

class SettingsRolesSuperAdmin extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      rolesList: [],
      permissionsStructure: null,
      permissionsStructureKeys: {},
      roleEdit: null,
      selectedRole: null,
      errorMessage: "",
      responseMessage: "",
    };
  }

  async componentDidMount() {
    this.getRole();
    this.getPermissionsStructure();
  }

  getRole = async () => {
    this.setState({
      errorMessage: null,
      selectedRole: null,
      isLoading: true,
      responseMessage: null,
    });

    try {
      const { data } = await getPermissionsStructureSuperAdminRequest();
      this.setState({ selectedRole: {...data, state: "active", name: "Active permissions", id: 1 } });
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      this.setState({
        subject: null,
        errorMessage: get(e, "response.data.error", "Error"),
      });
    }

    this.setState({ isLoading: false });
  };

  getPermissionsStructure = async () => {
    this.setState({
      errorMessage: null,
      isLoading: true,
      responseMessage: null,
    });

    try {
      const { data } = await getPermissionsStructureRequest({ all: true });

      const permissionsStructure = {};
      const permissionsStructureKeys = {};

      forEach(data, (item) => {
        const permissionItem = {};
        const permissions = [...item.permissions];
        const selectType = {};
        const checkboxType = [];

        permissions.forEach(
          ({ id, key, value, type, message, label, group }) => {
            permissionsStructureKeys[key] = `${id}`;

            if (group) {
              selectType[`group_${group.id}`] = selectType[`group_${group.id}`]
                ? [
                    ...selectType[`group_${group.id}`],
                    { key: `${id}`, value, name: group.name },
                  ]
                : [{ key: `${id}`, value, name: group.name }];
            } else {
              checkboxType.push({
                key: `${id}`,
                name: value,
                label: label ? label : message ? { type, message } : null,
              });
            }
          }
        );

        permissionItem.name = item.value;
        permissionItem.fields = [
          ...Object.keys(selectType).map((key) => ({
            key,
            name: get(selectType, `${key}[0].name`),
            permissions: selectType[key],
          })),
        ];

        if (checkboxType.length > 0) {
          permissionItem.fields = [...permissionItem.fields, ...checkboxType];
        }

        permissionsStructure[item.id] = permissionItem;
      });

      this.setState({ permissionsStructure, permissionsStructureKeys });
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      this.setState({
        subject: null,
        errorMessage: get(e, "response.data.error", "Error"),
      });
    }

    this.setState({ isLoading: false });
  };

  onSelectRole = (role) => () => {
    this.setState({ selectedRole: null }, () => {
      this.setState({ selectedRole: role });
    });
  };

  onRoleEditHide = () => {
    this.setState({ selectedRole: null });
  };

  onRoleEditSubmit = async () => {
    this.props.setPermissions(this.props.userToken);
    await this.getRole();
  };


  render() {
    const {
      errorMessage,
      responseMessage,
      permissionsStructure,
      permissionsStructureKeys,
      selectedRole,
      isLoading
    } = this.state;

    return (
      <div style={{ backgroundColor: "#FAFAFA" }}>
        <Layout className={classes.parentContainer}>
          <Content className={classes.content}>
            <h3 className="headline-default">
              {this.props.i18n.t("NamespaceSettingsRoles:Active Permissions")}
            </h3>
            <Breadcrumb>
              <Breadcrumb.Item href="/admin/settings">
                {this.props.i18n.t("Admin Settings")}
              </Breadcrumb.Item>
              <Breadcrumb.Item>
                {this.props.i18n.t("NamespaceSettingsRoles:Active Permissions")}
              </Breadcrumb.Item>
            </Breadcrumb>
            <br />

            <Row gutter={24}>
              <Col lg={24}>
                {isLoading && <Icon type="loading" />}

                {selectedRole && permissionsStructure && (
                  <SettingsRoleSuperAdminForm
                    permissionsStructureKeys={permissionsStructureKeys}
                    permissionsStructure={permissionsStructure}
                    {...selectedRole}
                    isNew={selectedRole && !selectedRole.id}
                    onSubmit={this.onRoleEditSubmit}
                    onCancel={this.onRoleEditHide}
                  />
                )}
              </Col>
            </Row>

            {errorMessage && <Alert type="error" message={errorMessage} />}

            {responseMessage && (
              <Alert type="success" message={responseMessage} />
            )}
          </Content>
        </Layout>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userToken: getUserToken(state),
});

const mapDispatchToProps = { logout, setPermissions };

export default isAuthenticated(
  connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(SettingsRolesSuperAdmin))
);



// WEBPACK FOOTER //
// ./src/containers/SettingsRoles/SettingsRolesSuperAdmin.js